<template>
  <v-chip v-if="isExcepcional" x-small label color="deep-orange lighten-5" text-color="deep-orange darken-3" class="excepcional-label">
    <v-icon x-small left>mdi-swap-horizontal-bold</v-icon>
    Movimiento excepcional
  </v-chip>
</template>

<script>
// ME-02: marca un movimiento como excepcional (cesión de un vehículo entre dealers del grupo).
export default {
  name: 'ExcepcionalLabel',
  props: {
    movement: { type: Object, default: null }
  },
  computed: {
    isExcepcional () {
      const v = this.movement && this.movement.is_excepcional
      return v === true || v === 1 || v === '1'
    }
  }
}
</script>
